import React, { useRef, useEffect, useState } from 'react'
import styles from './index.module.scss'
import Prism from 'prismjs'
import 'prismjs/themes/prism-okaidia.css'
import { CodeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
import { CopyOutlined } from '@ant-design/icons';
import { Typography } from 'antd';

const { Paragraph, Text } = Typography;

function PrismCode({ code, language, plugins = [], collapse = true }) {
    const ref = useRef(null)
    const [isCollapse, setIsCollapse] = useState(collapse);

    useEffect(() => {
        if (ref && ref.current) {
            Prism.highlightElement(ref.current)
        }
    }, [code])


    const changeShowCode = function () {
      setIsCollapse(!isCollapse)
    }

    return (
      <div className={styles.codes}>
        <div className={styles.tools}>
            <Paragraph
              copyable={{
                icon: [<CopyOutlined className={styles.svgStyle}/>],
                text: code,
                tooltips: ['复制', '复制成功!!'],
              }}
            ></Paragraph>
          <div className={styles.codeCollapse} onClick={changeShowCode}>
            {
              isCollapse ?  <EyeInvisibleOutlined className={styles.svgStyle} /> : <CodeOutlined className={styles.svgStyle}/>
            }
          </div>
        </div>
        <div className={[styles.code, !isCollapse ? styles.noCode : ''].join(' ')}>
          <pre className={plugins.join(' ')}>
            <code ref={ref} className={`prism-code language-${language}`}>
              {code}
            </code>
          </pre>
        </div>
      </div>
    )
}

export default PrismCode
